<template>
    <div>
        <div class="images" v-if="images.length > 0 || canUpload" flex="">
            <div class="item" v-for="(c,i) in images" :key="i" :draggable="true"
                @dragstart="dragstart(i)"
                @dragenter="dragenter(i,$event)"
                @dragend="dragend(i,$event)"
                @dragover="dragover($event)"
                :class="{'move': currentMoveKey == i, 'enter': currentEnterKey == i}"
            >
                <div class="image" flex="cross:center main:center">
                    <CImage :url="c" v-if="c.indexOf('.pdf') == -1" width="120" height="120"></CImage>
                    <CImage url="/images/pdf.jpeg" v-else width="120" height="120"></CImage>
                </div>
                <div class="text" v-if="!disabled" flex="cross:center main:center" @click="deleteImage(i)"><i class="el-icon-close"></i></div>
            </div>
            <Upload :moduleName="moduleName" v-if="canUpload" :type="10" @success="uploadSuccess"></Upload>
        </div>
        <div class="intro" v-if="images.length > 0 && !disabled">*温馨提示： 可拖动图片进行排序</div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            default: []
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        canUpload: {
            type: Boolean,
            default: false
        },
        moduleName: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            currentMoveKey: -1,
            currentEnterKey: -1,
        }
    },
    computed: {
        showImages(){
            if(!this.images || this.images.length == 0){
                return []
            }
            let images = []
            this.images.forEach(item => {
                images.push(this.$util.img(item))
            })
            return images
        }
    },
    methods: {
        deleteImage(key){
            this.$emit("deleteImage", key);
        },
        dragstart(key, e){
            this.currentMoveKey = key
        },
        dragenter(key, e){
            this.currentEnterKey = key
            e.preventDefault()
        },
        dragend(key, e){
            if(this.currentMoveKey != this.currentEnterKey){
                // 
                let newItems = [...this.images]
                // 删除老的节点
                newItems.splice(this.currentMoveKey, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(this.currentEnterKey, 0, this.images[this.currentMoveKey])
                this.$emit('moveImage', newItems)
            }
            this.currentMoveKey = -1
            this.currentEnterKey = -1
        },
        dragover(e){
            e.preventDefault()
        },
        uploadSuccess(res){
            this.$emit('uploadSuccess', res)
        }
    }
}
</script>

<style scoped lang="scss">
    .images{
        flex-wrap: wrap;
        .item{
            position: relative;
            width: 120px;
            height: 120px;
            border: 1px dashed #aaa;
            font-size: 0;
            margin-right: 15px;
            margin-bottom: 15px;
            .image{
                width: 120px;
                height: 120px;
            }
            .text{
                position: absolute;
                width: 20px;
                height: 20px;
                background: red;
                right: -10px;
                top: -10px;
                border-radius: 10px;
                color: #fff;
                font-size: 14px;
                cursor: pointer;
            }
            &.move{
                opacity: 0.1;
            }
            &.enter{
                border: 1px solid green;
                .image{
                    opacity: 0.2;
                }
            }
        }
    }
    .intro{
        color: #999;
    }
</style>


// WEBPACK FOOTER //
// src/components/MoreImage.vue